import { createSelectorHook } from "react-redux";
import CoreReduxContext from "../contexts/CoreReduxContext";
import { UseSelector } from "react-redux/es/hooks/useSelector";

const useCoreSelector: UseSelector = createSelectorHook(CoreReduxContext);

export default useCoreSelector;
